const o = (r) => {
  if (!r)
    return "";
  const n = new URLSearchParams();
  return Object.keys(r).forEach((t) => {
    const e = r[t];
    e != null && n.append(t, e.toString());
  }), n.toString();
};
export {
  o as generateQueryString
};
